export const fetchPortfolioData = async () => {
  try {
    const response = await fetch('https://docs.google.com/spreadsheets/d/e/2PACX-1vSf5HAKNAXB68rNpHgSvOSaKJDii6mq8yhp4OUN6rbKy3KwtrE2iiQgqRNtE00mTZ45U2wpKa9jU1V1/pub?gid=0&single=true&output=csv');
    
    if (!response.ok) {
      throw new Error('Failed to fetch data');
    }
    
    const csvText = await response.text();
    return parseCSV(csvText);
  } catch (error) {
    console.error('Error fetching portfolio data:', error);
    throw error;
  }
};

const parseCSV = (csvText) => {
  const lines = csvText.trim().split('\n');
  const headers = lines[0].split(',').map(header => header.trim().toLowerCase());
  
  const data = [];
  for (let i = 1; i < lines.length; i++) {
    const values = parseCSVLine(lines[i]);
    const row = {};
    
    headers.forEach((header, index) => {
      row[header] = values[index] || '';
    });
    
    // Only add rows that have at least a name
    if (row.name && row.name.trim()) {
      data.push(row);
    }
  }
  
  return data;
};

const parseCSVLine = (line) => {
  const result = [];
  let current = '';
  let inQuotes = false;
  
  for (let i = 0; i < line.length; i++) {
    const char = line[i];
    
    if (char === '"') {
      inQuotes = !inQuotes;
    } else if (char === ',' && !inQuotes) {
      result.push(current.trim());
      current = '';
    } else {
      current += char;
    }
  }
  
  result.push(current.trim());
  return result;
};